import { render, staticRenderFns } from "./InvestmentsSettings.vue?vue&type=template&id=607491b0&"
import script from "./InvestmentsSettings.vue?vue&type=script&lang=js&"
export * from "./InvestmentsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports